import { assignMedicalUserToPatient, getMedicalUserByRole } from "@/utils/apis/medicaluser-service";
import { useAuthStore } from "@/utils/stores/useAuthStore";
import { ExpertRole } from "../types/ExpertRole";
import { createExpertFromCalendlyExpert } from "../utils/createExpertFromCalendlyExpert";
import { getRandomExpert } from "../utils/getRandomExpert";

const useAssignPhysician = () => {
    const { auth } = useAuthStore()
    const idToken = auth.idToken
    const userId = auth.userId

    const assignPhysician = async (onSuccess?: () => void, onError?: () => void) => {
        if (!idToken || !userId) return;

        try {
            const physicians = await getMedicalUserByRole(idToken, ExpertRole.Physician);

            if (physicians && physicians.length > 0) {
                const physician = getRandomExpert(physicians);
                const newExpert = createExpertFromCalendlyExpert(physician);
                assignPhysi(newExpert.id!, `${physician.data.name} ${physician.data.family_name}`, onSuccess, onError);
            } else {
                console.warn("No physicians found.");
                onError?.();
            }
        } catch (error) {
            console.error("Error fetching physicians:", error);
            onError?.();
        }
    };

    const assignPhysi = async (physiId: string, phisyName: string, onSuccess?: () => void, onError?: () => void) => {
        if (!userId || !idToken) return;

        const physician = await assignMedicalUserToPatient(
            physiId,
            userId,
            idToken,
        )
        if (physician) {
            console.log(`[PHYSICIAN]: ${phisyName} assigned to user=${userId}`)
            onSuccess?.()
        } else {
            console.error("Physician not assigned");
            onError?.();
        }
    };

    return { assignPhysician };
};

export default useAssignPhysician;